/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentScope } from '../../models/attachment-scope';
import { StorageObjectDtoPage } from '../../models/storage-object-dto-page';

export interface ListWorkPackageStorageObjects$Params {
  assetId?: string | null;
  contentTypes?: Array<string>;
  name?: string;
  scopes?: Array<AttachmentScope>;
  projectIds?: Array<string>;
  tenantId?: string | null;
  workPackageIds?: Array<string>;
  parentId?: string;
  query?: string;
  createdById?: string | null;
  assigneeIds?: Array<string>;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  dynamicFilters?: string;
  isExpired?: boolean | null;
  startFrom?: string | null;
  startTo?: string | null;
  endFrom?: string | null;
  endTo?: string | null;
  ids?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'contentType' | '-contentType' | 'contentLength' | '-contentLength' | 'assetId' | '-assetId' | 'scope' | '-scope' | 'tags' | '-tags' | 'createdAt' | '-createdAt'>;
}

export function listWorkPackageStorageObjects(http: HttpClient, rootUrl: string, params?: ListWorkPackageStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<StorageObjectDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageStorageObjects.PATH, 'get');
  if (params) {
    rb.query('assetId', params.assetId, {});
    rb.query('contentTypes', params.contentTypes, {});
    rb.query('name', params.name, {});
    rb.query('scopes', params.scopes, {});
    rb.query('projectIds', params.projectIds, {});
    rb.query('tenantId', params.tenantId, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('parentId', params.parentId, {});
    rb.query('query', params.query, {});
    rb.query('createdById', params.createdById, {});
    rb.query('assigneeIds', params.assigneeIds, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('isExpired', params.isExpired, {});
    rb.query('startFrom', params.startFrom, {});
    rb.query('startTo', params.startTo, {});
    rb.query('endFrom', params.endFrom, {});
    rb.query('endTo', params.endTo, {});
    rb.query('ids', params.ids, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StorageObjectDtoPage>;
    })
  );
}

listWorkPackageStorageObjects.PATH = '/v0/files/work-packages';
